import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Constant } from '../common/constant';

@Injectable({
  providedIn: 'root'
})
export class InactivityTimeoutService {
  private readonly INACTIVITY_TIMEOUT_MS = 10 * 60 * 1000;
  private timeoutId: any;
  private destroyed$ = new Subject<void>();

  constructor(private http: HttpClient, private router: Router, private toaster: ToastrService) {}

  start(): void {
    if (!sessionStorage.getItem('token')) {
      return;
    }
    this.setupActivityListeners();
    this.resetTimer();
  }

  stop(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.destroyed$.next();
    this.destroyed$.complete();
    this.destroyed$ = new Subject<void>();
  }

  resetTimer(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    this.timeoutId = setTimeout(() => {
      this.handleInactivityTimeout();
    }, this.INACTIVITY_TIMEOUT_MS);
  }

  private setupActivityListeners(): void {
    const events = ['mousemove', 'mousedown', 'keypress', 'touchstart', 'scroll', 'wheel'];
    const sources = events.map(eventName => fromEvent(document, eventName));
    if (sources.length > 0) {
      merge(...sources)
        .pipe(takeUntil(this.destroyed$))
        .subscribe(() => this.resetTimer());
    }
  }

  private handleInactivityTimeout(): void {
    this.toaster.warning('Session expired due to inactivity. Please log in again.');
    const url = Constant.REST_URL + Constant.LOGOUT;
    this.http.post(url, {}).subscribe({
      complete: () => {
        sessionStorage.clear();
        this.router.navigate(['/']);
      },
      error: () => {
        sessionStorage.clear();
        this.router.navigate(['/']);
      },
    });
    this.stop();
  }
}
